import buildPath from './model-path-builder'
import { isVan } from '../category-matcher'

export default (make, allModels) => (model) => {
  const image = model.thumbnailImages

  return {
    model: `${model.name}`,
    make: make.name,
    price: model.price,
    path: buildPath(make, allModels, model),
    image: image,
    details: [],
    category: model.category,
    motability: model.motabilityAvailable && {
      downpayment: model.motabilityDownpayment,
      price: model.motabilityPrice
    },
    order: model.order || 0
  }
}
